export const messagesEn = {
  server: {
    exception: {
      badcredentials: "Please use a valid username or password!",
      accessdenied: "Access is denied!",
      unknown: "Unknown error occurred. Please try again later!",
      UNKNOWN_USER: "User could not be found! Please login again!",
      authentication: {
        USERNAME_DOES_NOT_EXIST:"Username does not exist. Please try again!",
        PASSWORD_DO_NOT_MATCH:"Password is not valid. Please try again!",
        TOKEN_COULD_NOT_BE_CREATED:"Error while trying to login. Please try again later!",
        COULD_NOT_GET_CURRENT_REQUEST:"Your session has been terminated. Please login again!",
        COULD_NOT_GET_CURRENT_TOKEN:"Your session has been terminated. Please login again!",
        NOT_BEARER_AUTHORIZATION:"Your session has been terminated. Please login again!",
        TOKEN_COULD_NOT_BE_REFRESHED:"Your session has been terminated. Please login again!",
        PRINCIPAL_MISMATCH:"Your session has been terminated. Please login again!",
        GOOGLE_SIGN_IN_FAILED: "Google sign in failed. Please try again later!",
        USER_IS_DISABLED: "Your account is disabled. Please contact support!",
      },
      registration: {
        REGISTRATION_FAILED: "Registration failed. Please try again later!",
        PASSWORD_TOO_WEAK: "Password is too weak. Please use another password!",
        HOTEL_ALREADY_REGISTERED: "This hotel has already been registered in another account!",
        COMPANY_ALREADY_EXISTS: "Company has already been registered!",
        PASSWORDS_DO_NOT_MATCH: "Passwords do not match!",
        SOCIAL_ACCOUNT_ALREADY_EXISTS: "This email has already been registered with a social account!",
        USERNAME_ALREADY_EXISTS: "This email has already been registered!",
        EMAIL_IS_NOT_VALID: "The email is not valid!",
        COMPANY_HOTEL_ALREADY_EXISTS: "One of the hotels has been already registered!",
        PROFILE_ALREADY_EXISTS: "This user has already been registered!",
        MAX_NUMBER_OF_COMPETITORS_SURPASSED: "You have reached the maximum number of competitors you can add in a property!",
        WEBHOTELIER_ID_ALREADY_EXISTS: "One of the Webhotelier IDs is already assigned to a registered property!",
        NO_WEBHOTELIER_ID: "Webhotelier ID is required for each registered property!",
      },
      profile: {
        PASSWORD_DOES_NOT_VALIDATE: "Password should be more than 8 characters!",
        PASSWORDS_DO_NOT_MATCH: "Passwords do not match!",
        USERNAME_ALREADY_EXISTS: "Email has been already registered!",
        EMAIL_IS_NOT_VALID: "Email is not valid!",
        WRONG_OLD_PASSWORD: "The current password is not valid!",
        RESET_PASSWORD_REQUEST_KEY_EXPIRED: "The reset password request has been expired. Please visit the 'Forgot Password' page again!",
        PROFILE_SETTINGS_NOT_FOUND: "Profile Settings could not be loaded!",
        PROFILE_ALREADY_EXISTS: "This user has already been registered!",
      },
      trip: {
        TRIP_HOTEL_ALREADY_EXISTS: "This hotel already exists. Please select another one!",
        TRIP_UPDATES_LIMIT_REACHED: "You have reached the maximum amount of updates for today!",
        TRIP_SHOULD_HAVE_AT_LEAST_ONE_HOTEL: "You need to have at least one hotel in your trip!"
      },
      companyHotel: {
        COMPANY_HOTEL_ALREADY_EXISTS: "This property is already defined!",
        COMPANY_HOTEL_NEED_AT_LEAST_ONE_COMPANY_HOTEL: "You need to have at least one property defined!",
        MAX_NUMBER_OF_COMPETITORS_SURPASSED: "You have reached the maximum number of competitors you can add in a property!"
      },
      marketState: {
        API_IS_NOT_AVAILABLE: "The service is not available at this time. Please try again later!"
      }
    }

  },
  common: {
    form: {
      error: {
        required: "This field is required!",
        email: "This field should be a valid email!"
      }
    }
  },
  org: {
    springframework: {
      security: {
        authentication: {
          DisabledException: "Your account is not verified. Please check your email or resend"
        }
      }
    }
  }
}
